//#region src/errors.ts
/**
* Error thrown when user input validation fails.
* These errors should be returned to the user directly without logging to Sentry.
*/
var UserInputError = class extends Error {
	constructor(message, options) {
		super(message, options);
		this.name = "UserInputError";
	}
};
/**
* Error thrown when configuration is invalid or missing.
* These errors should be returned to the user directly without logging to Sentry.
* Typically used for environment configuration issues, connection settings, etc.
*/
var ConfigurationError = class extends Error {
	constructor(message, options) {
		super(message, options);
		this.name = "ConfigurationError";
	}
};
/**
* Error thrown when an LLM provider (OpenAI, Anthropic, OpenRouter, etc.) rejects
* or cannot complete a request due to availability issues: region restrictions,
* budget/quota exhaustion, rate limits, or provider outages.
* These errors should be returned as graceful tool failures and logged as
* warnings — not filed as per-request Sentry issues.
*/
var LLMProviderError = class extends Error {
	constructor(message, options) {
		super(message, options);
		this.name = "LLMProviderError";
	}
};
/**
* Unexpected failure inside an embedded agent run (for example the AI SDK
* finishing without structured output).
*
* These are real bugs/operational defects and MUST create a Sentry issue once
* at the agent boundary. Callers should still degrade gracefully (fallback or
* formatted tool error) instead of hard-failing the parent MCP tool. The issue
* is filed before this error is thrown; do not call logIssue again for it.
*/
var AgentExecutionError = class extends Error {
	eventId;
	constructor(message, options) {
		super(message, options);
		this.name = "AgentExecutionError";
		this.eventId = options?.eventId;
	}
};

//#endregion
export { AgentExecutionError, ConfigurationError, LLMProviderError, UserInputError };
//# sourceMappingURL=errors-CEDWDXew.js.map